module.exports = __webpack_public_path__ + "static/01-96133d91e4ca86eeff7bf95da15e9c16.jpg";